import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import User from "../../../assets/img/icons/user3.png";
import config from "../../../config";
import { encrypt } from "../../../utils/crypto";
import AttendenceModelPopup from "../../../components/modelpopup/AttendenceModelPopup";
import AttendanceCountSummary from "../../../components/AttendanceCountSummary";
import moment from "moment";
import { CgSandClock } from "react-icons/cg";
import { MdCelebration } from "react-icons/md";
import { GiPalmTree } from "react-icons/gi";

const TableAvatar = ({
  uniqueDatesForMonth,
  paginatedData,
  setReRenderAttandanceData,
  companyWorkingDays,
}) => {
  const navigate = useNavigate();
  const [employeeAttendanceData, setEmployeeAttendanceData] = useState({});
  const today_date = moment().format("YYYY-MM-DD");
  const currentDate = new Date(today_date);
  const isToday = (date) => {
    const today = new Date(today_date);
    const inputDate = typeof date === "string" ? new Date(date) : date;
    return (
      inputDate?.getFullYear() === today?.getFullYear() &&
      inputDate?.getMonth() === today?.getMonth() &&
      inputDate?.getDate() === today?.getDate()
    );
  };

const calculateAttendanceCount = (data) => {
  if (!data?.attendance) {
    return {
      present: 0,
      total: 0,
      halfDay: 0,
      absent: 0,
      weekOff: 0,
      leave: 0,
      holiday: 0,
    };
  }

  let present = 0, halfDay = 0, absent = 0, weekOff = 0, leave = 0, holiday = 0;

  Object.values(data.attendance).forEach((attendance) => {
    if (!attendance || !attendance.status) return;

    const attendanceDate = new Date(attendance.date);
    const isFutureDate = attendanceDate > currentDate;
    const islastWorkingDate = data?.last_working_date
      ? isDateInvalid(data.last_working_date, attendance.date)
      : false;
    const isTodayDate = isToday(attendanceDate);
    const status = attendance.status;

    if (isFutureDate || islastWorkingDate) return;

    if (status === "PR") {
      present++;
    } else if (status === "HD") {
      halfDay++;
    } else if (status === "WO") {
      weekOff++;
    } else if (status === "LA") {
      leave++;
    } else if (status === "HO") {
      holiday++;
    } else if (status === "AB") {
      if (!isTodayDate) {
        absent++;
      }
    }
  });
  const total = (companyWorkingDays || 0) + weekOff + leave + holiday;

  return { present, total, halfDay, absent, weekOff, leave, holiday };
};

  const attendanceHandler = (attendance, isFutureDate, employeeName) => {
    setEmployeeAttendanceData({ ...attendance, employeeName });
  };
  function isDateInvalid(lastWorkingDateStr, checkDateStr) {
    
    const lastWorkingDate = new Date(lastWorkingDateStr);
    const checkDate = new Date(checkDateStr);

    const lastDate = lastWorkingDate.toISOString().split("T")[0];
    const checkDateOnly = checkDate.toISOString().split("T")[0];

    const nextDay = new Date(lastDate);
    nextDay.setDate(nextDay.getDate());
    return nextDay < checkDate;
  }

  return (
    <div className="table-responsive pb-3">
      <table className="table table-striped custom-table table-nowrap mb-0">
        <thead>
          <tr>
            <th className="sticky-column" style={{ paddingLeft: "20px" }}>
              Employee
            </th>
            <th style={{ paddingLeft: "20px", minWidth: "120px" }}>
              Attendance Count
            </th>
            {uniqueDatesForMonth?.length > 0 &&
              uniqueDatesForMonth.map((date, index) => (
                <th key={index} style={{ paddingLeft: "30px" }}>
                  {date}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {paginatedData?.length > 0 ? (
            paginatedData.map((data, index) => {
              const encryptedEmployeeId = encrypt(data?.employeeId);
              const attendanceCount = calculateAttendanceCount(data);
              const totalMonthDays = uniqueDatesForMonth?.length || 0;
              
              return (
                <tr key={index}>
                  <td
                    className="sticky-column cursor-pointer"
                    onClick={() =>
                      navigate(`../leave-dashboard/${encryptedEmployeeId}`, {
                        state: {
                          employeeName: data?.employeeName,
                        },
                      })
                    }
                  >
                    <h2
                      className="table-avatar"
                      style={{ color: "var(--bs-gray-900) !important" }}
                    >
                      <span className="avatar avatar-xs">
                        <img
                          alt=""
                          src={
                            data?.photo
                              ? `${config.IMAGE_URL}${data?.photo}`
                              : User
                          }
                        />
                      </span>
                      {data?.employeeName}
                    </h2>
                  </td>
                  <td style={{ paddingLeft: "20px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <span style={{ fontWeight: "600", fontSize: "14px" }}>
                        {attendanceCount.present + attendanceCount.weekOff + attendanceCount.leave + attendanceCount.holiday + (attendanceCount.halfDay * 0.5)}/{totalMonthDays}
                      </span>
                      <AttendanceCountSummary summary={attendanceCount} />
                    </div>
                  </td>
                  {uniqueDatesForMonth.map((date, dateIndex) => {
                    const attendance = data?.attendance[date];
                    const allow_attendance = data?.allow_attendance;
                    const attendanceDate = new Date(attendance?.date);
                    const isFutureDate = attendanceDate > currentDate;
                    const islastWorkingDate = data?.last_working_date
                      ? isDateInvalid(data?.last_working_date, attendance?.date)
                      : false;

                    return (
                      <td key={dateIndex}>
                        <div
                          style={{
                            backgroundColor:
                              allow_attendance == 1 && isToday(attendanceDate)
                                ? "#e5e7eb"
                                : attendance?.status === "PR" ||
                                  attendance?.status === "HD"
                                ? isToday(attendanceDate)
                                  ? "#e5e7eb" // Blue for today if Present
                                  : attendance?.approved_full_day === 1
                                  ? "#2aad40" // Green if approved_full_day
                                  : attendance?.background || "#000000"
                                : isFutureDate || islastWorkingDate
                                ? ""
                                : isToday(attendanceDate) &&
                                  attendance?.status === "AB" &&
                                  attendance?.punchIn != null
                                ? "#e5e7eb"
                                : attendance?.background || "#FF0000",
                            // padding: "5px 10px",
                            borderRadius: "50%",
                            alignItems: "center",
                            textAlign: "center",
                            color:
                              allow_attendance == 1 && isToday(attendanceDate)
                                ? "#e5e7eb"
                                : attendance?.status === "PR" ||
                                  attendance?.status === "HD"
                                ? isToday(attendanceDate)
                                  ? "#e5e7eb" // Blue for today if Present
                                  : attendance?.approved_full_day === 1
                                  ? "#2aad40" // Green if approved_full_day
                                  : attendance?.color || "#000000"
                                : isFutureDate || islastWorkingDate
                                ? ""
                                : isToday(attendanceDate) &&
                                  attendance?.status === "AB" &&
                                  attendance?.punchIn != null
                                ? "#e5e7eb"
                                : attendance?.color || "#FF0000",
                            padding: "7px 10px",
                            borderRadius: "50%",
                          }}
                        >
                          {isFutureDate || islastWorkingDate ? (
                            <span>-</span>
                          ) : allow_attendance == 1 &&
                            isToday(attendanceDate) ? (
                            <Link
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#attendance_info"
                              onClick={() =>
                                attendanceHandler(
                                  attendance,
                                  isFutureDate,
                                  data?.employeeName
                                )
                              }
                            >
                              <span>
                                <i
                                  class="fa-solid fa-check"
                                  style={{ color: "#6d7584" }}
                                ></i>
                              </span>
                            </Link>
                          ) : attendance?.status === "PR" ||
                            attendance?.status === "HD" ? (
                            <Link
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#attendance_info"
                              onClick={() =>
                                attendanceHandler(
                                  attendance,
                                  isFutureDate || islastWorkingDate,
                                  data?.employeeName
                                )
                              }
                            >
                              {" "}
                              {isToday(attendanceDate) ? (
                                <i
                                  class="fa-solid fa-check"
                                  style={{ color: "#6d7584" }}
                                ></i>
                              ) : attendance?.status === "HD" ? (
                                <i
                                  class="fa-solid fa-hourglass-half"
                                  style={{ color: attendance?.color }}
                                ></i>
                              ) : attendance?.status === "PR" ? (
                                <i
                                  class="fa-solid fa-check"
                                  style={{ color: attendance?.color }}
                                ></i>
                              ) : attendance?.status === "WO" ? (
                                <MdCelebration
                                  style={{ color: attendance?.color }}
                                  size={18}
                                />
                              ) : attendance?.status === "LA" ? (
                                <i
                                  class="fa-solid fa-plane-arrival"
                                  style={{
                                    color: attendance?.color,
                                    fontSize: "12px",
                                  }}
                                ></i>
                              ) : attendance?.status === "HO" ? (
                                <GiPalmTree
                                  style={{ color: attendance?.color }}
                                  size={18}
                                />
                              ) : (
                                <i
                                  class="fa-solid fa-xmark"
                                  style={{ color: attendance?.color }}
                                ></i>
                              )}{" "}
                            </Link>
                          ) : (
                            <Link
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#attendance_info"
                              onClick={() =>
                                attendanceHandler(
                                  attendance,
                                  isFutureDate,
                                  data?.employeeName
                                )
                              }
                            >
                              <span
                              // style={{
                              //   color:
                              //     isToday(attendanceDate) &&
                              //     attendance?.status === "AB" &&
                              //     attendance?.punchIn != null
                              //       ? "#0000FF"
                              //       : attendance?.color || "#FF0000", // Default to red for cross
                              // }}
                              >
                                {isToday(attendanceDate) &&
                                attendance?.status === "AB" &&
                                attendance?.punchIn != null ? (
                                  <i
                                    class="fa-solid fa-check"
                                    style={{ color: "#6d7584" }}
                                  ></i>
                                ) : attendance?.status == "NR" ? (
                                  <i
                                    class="fa-solid fa-xmark"
                                    style={{ color: attendance?.color }}
                                  ></i>
                                ) : attendance?.status == "WO" ? (
                                  <MdCelebration
                                    style={{ color: attendance?.color }}
                                    size={18}
                                  />
                                ) : attendance?.status === "LA" ? (
                                  <i
                                    class="fa-solid fa-plane-departure"
                                    style={{
                                      color: attendance?.color,
                                      fontSize: "12px",
                                    }}
                                  ></i>
                                ) : attendance?.status === "HO" ? (
                                  <GiPalmTree
                                    style={{ color: attendance?.color }}
                                    size={18}
                                  />
                                ) : (
                                  <i
                                    class="fa-solid fa-xmark"
                                    style={{ color: attendance?.color }}
                                  ></i>
                                )}{" "}
                              </span>
                            </Link>
                          )}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan={uniqueDatesForMonth.length + 2}
                className="text-center"
              >
                No Attendance Found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <AttendenceModelPopup
        employeeAttendanceData={employeeAttendanceData}
        isToday={isToday}
        setReRenderAttandanceData={setReRenderAttandanceData}
      />
    </div>
  );
};

export default TableAvatar;
